export enum CHOICE_TYPES {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

export enum IconType {
  icon = 'icon',
  emoji = 'emoji',
  image = 'image',
}
